import styles from "./Button.module.css";

export enum EButtonColors {
  Green = "green",
  Red = "red",
  Blue = "blue",
  Clear = "clear",
  Gray = "gray",
  TransparentWhite = "transparentWhite",
  LinkWhite = "linkWhite",
}

export interface IButton {
  className?: string | undefined;
  color: EButtonColors;
  text: string;
  disabled?: boolean;
  width?: number;
  height?: number;
  onClick: () => void;
  type?: "button" | "submit" | "reset" | undefined;
}

const Button: React.FC<IButton> = ({ text, type = "button", color, disabled = false, width = 200, height = 44, onClick }) => {
  const handleOnClick = () => {
    if (disabled) {
      return;
    }
    onClick();
  };

  return (
    <button
      disabled={disabled}
      style={{ width, height }}
      onClick={handleOnClick}
      className={`${styles.container} ${styles[color]}`}
      type={type}
    >
      {text}
    </button>
  );
};

export default Button;
